import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js/min'

const names = new Intl.DisplayNames(['es'], { type: 'region' })
const preferred = ['EC', 'CO', 'PE', 'AR', 'CL', 'MX', 'US', 'ES']
export const phoneCountries = getCountries().map(code => ({
  code, name: names.of(code), prefix: '+' + getCountryCallingCode(code),
})).sort((a, b) => {
  const ai = preferred.indexOf(a.code), bi = preferred.indexOf(b.code)
  if (ai >= 0 || bi >= 0) return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi)
  return a.name.localeCompare(b.name, 'es')
})

// Parse the entire value. Never silently extract a number from arbitrary text.
export function contactPhone(value, country = 'EC') {
  const raw = String(value || '').trim().replace(/^00/, '+')
  if (!raw) return { number: '', national: '', country, valid: false }
  if (!/^[+\d() .-]+$/.test(raw)) return { number: raw, national: raw, country, valid: false }
  const parsed = parsePhoneNumberFromString(raw, { defaultCountry: country, extract: false })
  if (!parsed) return { number: raw, national: raw, country, valid: false }
  return { number: parsed.number, national: parsed.nationalNumber, country: parsed.country || country, valid: parsed.isPossible() }
}

export function whatsappContactUrl(contact) {
  // Only accept the server's approved WhatsApp link; hidden/opted-out contacts
  // must never get a link synthesized from other customer details.
  const url = String(contact?.whatsapp_url || '')
  return /^https:\/\/wa\.me\/[1-9]\d{7,14}$/.test(url) ? url : ''
}
